<template>
  <div v-show="isShow" class="c-gnav" :class="{'c-gnav--show': isShow}">
    <a class="c-gnav__logoST50" href="#">
      <img v-if="logoFile" :src="`${assets_path}images/common/${logoFile}`" :alt="logoAlt" width="393" height="21">
    </a>

    <div class="c-gnav__wrap">
      <div class="c-gnav__wrapCol f-Cal-Mid">
        <dl v-if="note.links">
          <dt class="c-gnav__wrapCol__title">{{note.links.contents}}</dt>
          <dd><a :href="urls.page_top">{{note.links.page_top}}</a></dd>
          <dd><a :href="urls.page_benefit">{{note.links.page_benefit}}</a></dd>
          <dd><a :href="urls.page_technology">{{note.links.page_technology}}</a></dd>
          <dd><a :href="urls.page_product">{{note.links.page_product}}</a></dd>
        </dl>
      </div>

      <div v-if="note.links" class="c-gnav__wrapCol c-gnav__wrapCol--locals">
        <dl>
          <dt class="c-gnav__wrapCol__title f-Cal-Mid">{{note.links.language}}</dt>
          <dd class="f-Cal-Mid"><a href="https://www.citizenwatch-global.com/titaniumtechnology50th/">
            <span v-html="note.nav.language[0].name"></span>
            <span>{{note.nav.language[0].link}}</span>
          </a></dd>
          <dd><a href="https://citizen.jp/titaniumtechnology50th/">
            <span class="f-Cal-Mid" v-html="note.nav.language[1].name"></span>
            <span>{{note.nav.language[1].link}}</span>
          </a></dd>
          <dd><a href="https://www.citizenwatch-global.com/titaniumtechnology50th/tc/">
            <span class="f-Cal-Mid" v-html="note.nav.language[2].name"></span>
            <span>{{note.nav.language[2].link}}</span>
          </a></dd>
          <dd><a href="https://www.citizenwatch-global.com/titaniumtechnology50th/sc/">
            <span class="f-Cal-Mid" v-html="note.nav.language[3].name"></span>
            <span>{{note.nav.language[3].link}}</span>
          </a></dd>
        </dl>
        <dl>
          <dd class="f-Cal-Mid"><a href="https://www.citizenwatch-global.com/titaniumtechnology50th/de/">
            <span v-html="note.nav.language[4].name"></span>
            <span>{{note.nav.language[4].link}}</span>
          </a></dd>
          <dd class="f-Cal-Mid"><a href="https://www.citizenwatch-global.com/titaniumtechnology50th/it/">
            <span v-html="note.nav.language[5].name"></span>
            <span>{{note.nav.language[5].link}}</span>
          </a></dd>
          <dd class="f-Cal-Mid"><a href="https://www.citizenwatch-global.com/titaniumtechnology50th/es/">
            <span v-html="note.nav.language[6].name"></span>
            <span>{{note.nav.language[6].link}}</span>
          </a></dd>
          <dd class="f-Cal-Mid"><a href="https://www.citizenwatch-global.com/titaniumtechnology50th/fr/">
            <span v-html="note.nav.language[7].name"></span>
            <span>{{note.nav.language[7].link}}</span>
          </a></dd>
        </dl>
      </div>

      <div class="c-gnav__wrapCol c-gnav__wrapCol--group">
        <dl v-if="note.links">
          <dt class="c-gnav__wrapCol__title f-Cal-Mid">{{note.links.links}}</dt>
          <dd><a :href="urls.citizen_tech" target="_blank">{{note.links.citizen_tech}}</a></dd>
          <dd><a :href="urls.citizen" target="_blank">{{note.links.citizen}}</a></dd>
          <dd><a :href="urls.globalnetwork" target="_blank">{{note.links.citizen_global}}</a></dd>
        </dl>
      </div>
    </div>

    <div v-if="note.links" class="c-gnav__footer">
      <p class="c-gnav__footer__cap f-Cal-Mid">{{note.links.official}} :</p>
      <ul class="c-gnav__sns">
        <li v-if="lang === 'zh-cmn-Hans'" @click="openQR('weibo')" @mouseenter="mouseenter('weibo')" @mouseleave="mouseleave('weibo')">
          <img class="icon-weibo" :src="`${assets_path}images/common/icon-weibo.png`" alt="weibo" width="26" height="20">
          <picture v-if="qrWeibo">
            <source media="(max-width: 900px)" :srcset="`${assets_path}images/common/qr/weibo-sp.png`" />
            <img ref="qr-weibo" class="c-gnav__snsQR" :src="`${assets_path}images/common/qr/weibo-pc.png`" alt="" width="125" height="134" />
          </picture>
        </li>
        <li v-if="lang === 'zh-cmn-Hans'" @click="openQR('wechat')" @mouseenter="mouseenter('wechat')" @mouseleave="mouseleave('wechat')">
          <img class="icon-wechat" :src="`${assets_path}images/common/icon-wechat.svg`" alt="wechat" width="24" height="20">
          <picture v-if="qrWechat">
            <source media="(max-width: 900px)" :srcset="`${assets_path}images/common/qr/wechat-sp.png`" />
            <img class="c-gnav__snsQR" :src="`${assets_path}images/common/qr/wechat-pc.png`" alt="" width="125" height="134" />
          </picture>
        </li>
        <li v-if="urls.fb"><a :href="urls.fb" target="_blank"><img class="icon-fb" :src="`${assets_path}images/common/icon-fb.svg`" alt="facebook" width="10" height="21"></a></li>
        <li v-if="urls.tw"><a :href="urls.tw" target="_blank"><img class="icon-tw" :src="`${assets_path}images/common/icon-tw.svg`" alt="twitter" width="21" height="17"></a></li>
        <li v-if="urls.insta"><a :href="urls.insta" target="_blank"><img class="icon-insta" :src="`${assets_path}images/common/icon-insta.svg`" alt="instagram" width="19" height="19"></a></li>
        <li v-if="urls.yt"><a :href="urls.yt" target="_blank"><img class="icon-yt" :src="`${assets_path}images/common/icon-yt.svg`" alt="youtube" width="20" height="14"></a></li>
      </ul>
    </div>

  </div>
</template>

<script>
  import {gsap, Cubic} from 'gsap/all';
  import { assets_path } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';

  export default {
    components: {

    },
    data() {
      return {
        lang: '',
        urls: {},
        note: {},
        assets_path: assets_path,
        isShow: false,
        logoAlt: '',
        logoFile: '',
        qrWeibo: false,
        qrWechat: false
      }
    },
    store,
    computed: {
      show() {
        return this.$store.getters.isShowGnav;
      }
    },
    watch: {
      show (val, old) {
        if (val) {
          this.open();
        } else {
          this.close();
        }
      }
    },
    created() {},
    mounted() {
      this.urls = this.$store.getters.getUrls;
      this.note = this.$store.getters.getNote;
      this.lang = this.$store.getters.getLang;
      this.ua = this.$store.getters.getUA;

      //console.log(this.ua.device.type);

      if (this.lang === "zh-cmn-Hans") {
        // sc
        this.logoFile = 'logo-st-sc.svg';
        this.logoAlt = '舒博钛';
      } else {
        this.logoFile = 'logo-st.svg';
        this.logoAlt = 'SUPER TITANIUM';
      }
    },
    methods: {
      open() {
        this.isShow = true;

        const title = this.$el.querySelector('.c-gnav__logoST50');
        const cols = this.$el.querySelectorAll('.c-gnav__wrapCol');
        const footer = this.$el.querySelectorAll('.c-gnav__footer');

        gsap.killTweensOf([
          this.$el,
          title,
          cols,
          footer
        ]);

        gsap.fromTo(this.$el,
          {opacity: 0},
          {duration: 0.6, opacity: 1}
        );

        gsap.fromTo(title,
          {opacity: 0},
          {duration: 0.7, delay: 0.1, opacity: 1, ease: Cubic.easeOut}
        );

        gsap.fromTo(cols,
          {opacity: 0, x: '10%'},
          {duration: 0.7, delay: 0.3, stagger: 0.08, opacity: 1, x: '0%', ease: Cubic.easeOut}
        );

        gsap.fromTo(footer,
          {opacity: 0},
          {duration: 0.7, delay: 0.3, opacity: 1, ease: Cubic.easeOut}
        );

      },
      close() {
        gsap.killTweensOf(this.$el);

        gsap.to(this.$el,
          {duration: 0.5, opacity: 0, ease: Cubic.easeOut, onComplete: this.closeComp}
        );
      },
      closeComp() {
        this.$el.scrollTop = 0;
        this.isShow = false;
      },
      onAnchor(e) {
        // ナビ閉じる
        this.$store.commit('setShowGnav', false);
        // アンカースクロール
        this.$_onAnchor(e);
      },
      triggerLinks(e) {
        e.preventDefault();
        if (this.$store.getters.isShowLinks) {
          this.$store.commit('setShowLinks', false);
        } else {
          this.$store.commit('setShowLinks', true);
        }
      },
      openQR(sns) {
        if (sns === 'weibo') {
          if (this.qrWeibo) {
            this.qrWeibo = false;
          } else {
            this.qrWeibo = true;
            this.qrWechat = false;
          }
        } else if (sns === 'wechat') {
          if (this.qrWechat) {
            this.qrWechat = false;
          } else {
            this.qrWechat = true;
            this.qrWeibo = false;
          }
        }
      },
      showQR(sns) {
        if (sns === 'weibo') {
          this.qrWeibo = true;
          this.qrWechat = false;
        } else if (sns === 'wechat') {
          this.qrWechat = true;
          this.qrWeibo = false;
        }
      },
      hideQR(sns) {
        if (sns === 'weibo') {
          this.qrWeibo = false;
        } else if (sns === 'wechat') {
          this.qrWechat = false;
        }
      },
      mouseenter(sns) {
        if (this.ua.device.type !== 'mobile' && this.ua.device.type !== 'tablet') {
          this.showQR(sns);
        }
      },
      mouseleave(sns) {
        if (this.ua.device.type !== 'mobile' && this.ua.device.type !== 'tablet') {
          this.hideQR(sns);
        }
      }
    }
  }
</script>
